import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { usePageMeta } from '../../utils/pageMeta';
import { getKategorijaById, getPodkategorijeByKategorijaId } from '../../server/server-kategorije-tree';
import { useUser } from '../../auth/UseUser';
import { TypeOfEtity } from '../../model/enum/typeOfEntity';
import { Oval } from 'react-loader-spinner';
import { ObrazovanjeItem } from './ObrazovanjeHome';

function KategorijaObrazovanjeHome() {
    const { id } = useParams<any>();
    const { navLista, setNavLista, returnedList, setReturnedList, setTipEtiteta } = useUser();
    const [mainList, setMainList] = useState<any[]>([]);
    const [kategorija, setKategorija] = useState<any>(null);
    usePageMeta(kategorija?.naziv, kategorija?.opis);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!!id) loadKategorija();
    }, [id]);

    const loadKategorija = async () => {
        setLoading(true);
        const resp = await getKategorijaById(id);
        if (resp.status == 200) {
            const item = resp.data;
            setKategorija(resp.data);
            setNavLista([item]);
            setTipEtiteta(TypeOfEtity.Podkategorija);
            setReturnedList(resp.data.podkategorije);
            setMainList(resp.data.podkategorije);
            setLoading(false);
        } else {
            setLoading(false);
        }
    };

    const loadPodkategorije = async (id: string | undefined) => {
        const resp = await getPodkategorijeByKategorijaId(id);
        if (resp.status === 200) {
        }
    };

    return (
        <div className="flex-1 flex h-full flex-col items-center overflow-y-auto bg-blueDark  no-scroll">
            <div className=" obrazovanje-outer-frame-mobile md:obrazovanje-outer-frame-web">
                <div className=" obrazovanje-inner-frame-mobile sm:obrazovanje-inner-frame-web">
                    {!loading && (
                        <>
                            <p className=" text-obrazovanje-title">
                                {kategorija?.naziv}: <span className="text-white">{kategorija?.opis}</span>
                            </p>
                            <div className="mt-6 flex flex-col gap-3">
                                {mainList.map((item: any, index: number) => {
                                    return <ObrazovanjeItem key={index} item={item} />;
                                })}
                            </div>
                        </>
                    )}
                    {loading && (
                        <div className="w-full flex-1 flex items-center justify-center">
                            <Oval />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default KategorijaObrazovanjeHome;
